import { useTranslations } from 'next-intl'

import { PyeongSize as PyeongSizeEnum } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'

import { Filter, useFilter } from '../../model/filter'
import { Item, List, Title } from '../common/layout'

const usePyeongSizes = () => {
  const t = useTranslations('filter')

  const PYEONG_SIZES = [
    {
      title: t('area_under_5'),
      value: PyeongSizeEnum.UNDER_FIVE,
    },
    {
      title: t('area_between_5_10'),
      value: PyeongSizeEnum.FROM_FIVE_TO_TEN,
    },
    {
      title: t('area_ten'),
      value: PyeongSizeEnum.RANGE_TEN,
    },
    {
      title: t('area_twenty'),
      value: PyeongSizeEnum.RANGE_TWENTY,
    },
    {
      title: t('area_thirty'),
      value: PyeongSizeEnum.RANGE_THIRTY,
    },
    {
      title: t('area_forty_or_more'),
      value: PyeongSizeEnum.OVER_FORTY,
    },
  ]

  return { PYEONG_SIZES }
}

type Props = {
  className?: string
}

export const PyeongSizes = ({ className }: Props) => {
  const t = useTranslations('filter')

  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    type,
    filter: { pyeongSizes },
    updateFilter,
  } = useFilter()

  const { PYEONG_SIZES } = usePyeongSizes()

  const handlePyeongSizeChange = (value: PyeongSizeEnum) => () => {
    updateFilter({ pyeongSizes: value })
  }

  return (
    <div
      className={className}
      ref={element => {
        if (element) {
          registerScrollElement(Filter.PyeongSizes, element)
        }
      }}
    >
      <Title>{t('area.title')}</Title>
      <List>
        {PYEONG_SIZES.map(({ title, value }) => (
          <Item
            key={title}
            type={type}
            selected={pyeongSizes.includes(value)}
            onClick={handlePyeongSizeChange(value)}
          >
            {title}
          </Item>
        ))}
      </List>
    </div>
  )
}
